'use strict';
const i18n = require('i18next');
const Notification = require('../index');

module.exports = Notification.extend({
    defaults: {
        sender: null,
        project: null,
        message: null,
        eventAt: null,
        version: 2
    },

    getTaskName() {
        return this.get('message').name;
    },

    getTaskID() {
        return this.get('message').id;
    },

    getProjectName() {
        return this.get('project').name;
    },

    getProjectID() {
        return this.get('project').id;
    },

    getTitle: function() {
        return this.getTaskName();
    },

    getIconClass: function() {
        return 'fa fa-check-square text-primary';
    },

    getSender: function() {
        return this.get('sender');
    },

    getSubTitle: function() {
        return `in ${this.getProjectName()}`;
    },

    getContent: function() {
        return i18n.t('notification:task.create.content');
    },

    getLinkURL: function() {
        return `/projects/${this.getProjectID()}#/tasks/${this.getTaskID()}`
    }
}, {
    type: 'task:create'
});



// WEBPACK FOOTER //
// ./notify/domain/entity/notification/task/create.js